// extracted by mini-css-extract-plugin
export var colourBase = "XuZr76nUYdYVDu84tKy7";
export var colourDisabled = "hLFf7D45VWLIv2_e9iPQ";
export var colourInverted = "j_X6NH_iFxJsTEIaJnoO";
export var colourNegative = "T3M8aJVdLJHurii6wytP";
export var colourPositive = "UqYLiMSllNiVBXi0x4yJ";
export var colourSubdued = "ux0lysI8mwbxLFqzXUdl";
export var colourSubtle = "axp2HCSiwkeyYFM6i5hA";
export var colourUrgencyHigh = "SR30jWfY8unll8GOBlBl";
export var colourUrgencyMedium = "y6URklMEm9DKIAu85M0_";
export var colourWarning = "HNaSy9TwHujQIUGraiS8";
export var colourWhite = "WaNK2P30dmbHclOQTClA";